import styled from 'styled-components/macro';

import { colors } from '../../styles/vars';

const TitleIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  margin-right: 10px;

  path {
    fill: ${colors['black-six']} !important;
  }
`;

export default TitleIcon;
